query PaymentsList(
  $page: Int
  $rowsPerPage: Int
  $filter: PaymentsFilterInput
) {
  payments(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      status
      provider
      amount {
        value
        currency
      }
      amountInOrganizationCurrency {
        value
        currency
      }
      providerFeeAmount {
        value
        currency
      }
      ottkitFeeAmount {
        value
        currency
      }
      organizationAmount {
        value
        currency
      }
      organizationAmountInOrganizationCurrency {
        value
        currency
      }
      buyerEmail
      userId
      product {
        id
        title
        type
      }
      period
      recurrent
      createdAt
      refunds {
        id
        status
        manual
        createdAt
        amount {
          value
          currency
        }
      }
    }
  }
}
